const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/LoginPage/InputField/styles.ts';
import { useTheme } from '@mui/material/styles';
import { css } from '@emotion/css';
import { colors } from '@cistec/common_web/defs/colors';
import { useMemo } from 'react';

export function useCSSClasses() {
    const theme = useTheme();
    return useMemo(
        () => ({
            root: css`
                &:hover:before {
                    border-color: rgba(255, 255, 255, 0.5) !important;
                }
            `,
            frame: css`
                flex: 0 0 auto;
                align-self: stretch;
                margin-right: ${theme.spacing(1)};
                background: ${theme.palette.common.white};
                border: ${colors.grey['400']} solid ${theme.spacing(1 / 8)};
                border-radius: ${theme.spacing(3 / 8)};
                width: ${theme.spacing(145 / 8)};

                // remove unnecessary little ugly arrows if inputfield's type is 'number'
                & input[type='number']::-webkit-outer-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }
                & input[type='number']::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }
                // also for firefox
                & input[type='number'] {
                    -moz-appearance: textfield;
                }
            `,
            smallDevice: css`
                margin: auto;
            `,
            underline: css`
                &:before {
                    border-color: rgba(255, 255, 255, 0.5);
                }
            `,
            focused: css`
                &:after {
                    border-color: ${theme.palette.common.white};
                }
            `,
            // ReactInputMask needs the same styles as MUI provides
            maskRoot: css`
                background: none;
                padding: 12px 0 7px !important;
                width: 100%;
                &:hover:before {
                    border-color: rgba(255, 255, 255, 0.5) !important;
                }
            `,
            maskFrame: css`
                & > input {
                    border: none;
                    border-color: ${colors.grey['400']};
                    outline: none;
                    color: ${colors.grey['800']};
                    padding: ${theme.spacing(1, 1)};
                    text-align: center;
                }
                & > input:focus,
                & > input:active {
                    border-color: ${colors.grey['400']};
                    box-shadow:
                        inset 0 1px 1px rgb(0 0 0 / 8%),
                        0 0 8px ${colors.grey['400']};
                }
            `,
            maskError: css`
                & > input {
                    border: none;
                    border-bottom-color: ${theme.palette.error.main};
                    outline: none;
                    border-bottom-width: 3px;
                    border-bottom-style: solid;
                }
                & > input:hover,
                & > input:focus,
                & > input:active {
                    border-color: ${theme.palette.error.main};
                    border-bottom-width: 3px !important;
                }
            `,
        }),
        [theme]
    );
}
